import * as React from 'react';
import { lazyHideFlexPane, lazyShowFlexPane } from 'owa-flex-pane';
import { observer } from 'mobx-react-lite';

export interface HeaderFlexPaneProps {
    content: JSX.Element;
    title: (() => string) | string;
    onDismiss: () => any;
}

const styles = require('./HeaderPane.scss');

const HeaderFlexPane = observer(function HeaderFlexPane(props: HeaderFlexPaneProps) {
    React.useEffect(() => {
        const { content, title, onDismiss } = props;

        lazyShowFlexPane.importAndExecute(
            <div className={styles.headerFlexPaneContentDiv}>{content}</div>,
            {
                headerText: title,
                onDismiss: onDismiss,
            }
        );
    }, []);
    React.useEffect(
        () => () => {
            lazyHideFlexPane.importAndExecute();
        },
        []
    );
    return null;
});
export default HeaderFlexPane;
